import { createSelector } from 'reselect';

import { getBucketList } from './getBucketList';

export const getSelectedBucketList = createSelector(
    getBucketList,
    (state) => state.storageBuckets.selection,
    (list, selection) => {
        return list.filter(({ Name }) => selection[Name] === true);
    },
);
